var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"standard-page"},[_c('profile',{attrs:{"user-id":_vm.userId,"starting-page":_vm.startingPage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }